
export class SetAndGetValue {
    public userId=""

    public setUserId(userId: any) {
        this.userId= userId;
    }

    public getUserId() {
        return this.userId;
    }
}